<template>
  <div class="question-detail">
    <div class="qd-container" ref="container">
      <!-- 站外广告栏 -->
      <swiperHead
        v-if="!$platform.isYixinliApp"
        errUrl="https://sdata.xinli001.com/t/5s"
      ></swiperHead>
      <!-- 自定义头部 -->
      <mobileHeader
        :alwaysShow="true"
        :goBack="navGoback"
        :customBackgroundColor="'#fff'"
        borderBottom="0 none"
        class="header"
        v-if="$platform.isYixinliApp"
      >
        <div class="header-content" slot="navTitle">
          <div class="flex-box">
            <div class="head-l" @click="navGoback">
              <img
                class="back-btn"
                src="~images/qa/anwser/page-top-arrow.png"
              />
            </div>
          </div>
          <servivesCard :isSticky="isSticky" @toServices="toServices" />
          <!-- <div class="header-m" v-if="isSticky">{{ detail.title }}</div> -->
          <div class="header-r">
            <img
              @click="handleShare"
              class="share-btn"
              src="~images/qa/anwser/page-top-more.png"
            />
          </div>
        </div>
      </mobileHeader>
      <!-- 问题详情 -->
      <questionContent></questionContent>

      <div class="gray-line" v-if="qaAnswerList.length"></div>
      <answerList
        v-show="qaAnswerList.length"
        ref="answerList"
        :questionId="questionId"
        :dataList="qaAnswerList"
        @goAnswerDes="goAnswerDes"
        @answerToUserHome="answerToUserHome"
        @answerLikeFinish="answerLikeFinish"
        @answerFollowFinish="answerFollowFinish"
        @answerReportFinish="answerReportFinish"
        @shareSuccess="shareSuccessFn"
      ></answerList>
      <template v-if="!qaAnswerList.length">
        <!-- 咨询师列表 -->
        <teacherList v-if="isConsultTarget" />
        <!-- 倾诉师列表 -->
        <qingsuList v-else />
      </template>

      <template v-if="problems.length">
        <div class="gray-line"></div>
        <similarityProblem :problems="problems"></similarityProblem>
      </template>

      <!-- 群组推荐 -->
      <template v-if="similarGroupList && similarGroupList.length">
        <div class="gray-line"></div>
        <recommedGroup :list="similarGroupList" />
      </template>

      <template v-if="articles.length">
        <div class="gray-line"></div>
        <relatedReading :articles="articles"></relatedReading
      ></template>

      <transition name="fade">
        <bottomBar
          v-if="inited"
          :detail="detail"
          :questionId="questionId"
          :isOnwer="isOnwer"
          @update="fetchQuestionDetail"
          @toAnswer="openAnswerDialog"
        ></bottomBar>
      </transition>
    </div>

    <answerDialog
      ref="answerDialog"
      :qaDetail="detail"
      :isShowToast="true"
      @update="
        id => {
          handlePoster(id)
          answerTrack()
          fetchQuestionDetail()
          refreshAnswerList()
        }
      "
      @toggleBodyVisiable="toggleBodyVisiable"
    ></answerDialog>

    <qaCommonAd v-if="renderQaCommonAd"></qaCommonAd>
    <poster ref="poster" :isPublish="true" />
  </div>
</template>

<script>
import { parseParamId } from 'utils/index.js'
import swiperHead from 'component/qa/swiperHead.vue'
import mobileHeader from 'component/qa/MobileHeader'
import questionContent from 'component/qa/questions/questionContent.vue'
import similarityProblem from 'component/qa/questions/similarityProblem.vue'
import relatedReading from 'component/qa/questions/relatedReading.vue'
import answerList from 'component/qa/questions/answerList.vue'
import teacherList from 'component/qa/questions/teacherListV2.vue'
import qingsuList from 'component/qa/questions/qingsuList.vue'
import bottomBar from 'component/qa/questions/bottomBar.vue'
import answerDialog from 'component/qa/questions/answerDialog.vue'
import qaCommonAd from 'component/qa/qaCommonAd.vue'
import servivesCard from 'component/qa/questions/servivesCard.vue'
import recommedGroup from 'component/qa/questions/recommedGroup.vue'
import qaQuestionDetailStore from 'store/qa/questionDetail.js'
import { commonGetToken, isObject } from 'utils/tool.js'
import hasShowCrisisMixin from 'mixins/qa/hasShowCrisisMixin.js'
import wechatShareMixin from 'lib/mixins/wechatShare.js'
import { increaseInvite } from 'api/qa/index.js'
import { getStatusBarHeight } from 'utils/tool.js'
import poster from 'component/qa/questions/poster.vue'

export default {
  mixins: [wechatShareMixin, hasShowCrisisMixin],
  dataStore: qaQuestionDetailStore,
  preFetch({ store, route }) {
    const id = parseParamId(route.params.id)
    return Promise.all([
      store
        .dispatch('qaQuestionDetail/fetchQuestionDetail', {
          id,
          icrSeeUnm: 1 // 用于后端计数，一个页面只触发一次detail接口即可
        })
        .then(res => {
          if (res.code === 0) {
            const content = res.data.content.substr(0, 270)
            store.commit('setMeta', {
              title: `${res.data.title}-壹心理`,
              keywords: `${res.data.tagNames}`,
              description: content
            })
          }
        }),
      store.dispatch('qaQuestionDetail/fetchQaAnwserList', {
        id,
        pageNo: 1,
        pageSize: 20
      }),
      store.dispatch('qaQuestionDetail/fetchSimilarityProblem', {
        questionId: id
      }),
      store.dispatch('qaQuestionDetail/fetchRelatedReading', {
        questionId: id
      }),
      store.dispatch('qaQuestionDetail/fetchSimilarGroup', {
        questionId: id,
        pageSize: 3
      })
    ])
  },
  provide() {
    return {
      questionTags: this.questionTags
    }
  },
  components: {
    qaCommonAd,
    answerList,
    relatedReading,
    similarityProblem,
    swiperHead,
    mobileHeader,
    questionContent,
    teacherList,
    bottomBar,
    answerDialog,
    servivesCard,
    qingsuList,
    recommedGroup,
    poster
  },
  data() {
    return {
      renderQaCommonAd: false,
      inited: false,
      isSticky: false
      // userData: {}
    }
  },
  computed: {
    qaAnswerList() {
      return this.$store.state.qaQuestionDetail.answerList || []
    },
    problems() {
      return this.$store.state.qaQuestionDetail.similarityProblem || []
    },
    articles() {
      return this.$store.state.qaQuestionDetail.relatedReading || []
    },
    authUser() {
      const { authUser } = this.detail
      return isObject(authUser) ? authUser : {}
    },
    detail() {
      return this.$store.state.qaQuestionDetail.detail || {}
    },
    questionTags() {
      return {
        filter_item_Platform: this.detail.dimensionTagNames || [], //平台维度
        first_class: this.detail.parentTagNames || [], //一级标签
        second_class: this.detail.tagNames || [] //二级标签
      }
    },
    questionId() {
      const id = this.$route.params.id
      return parseParamId(id)
    },
    isOnwer() {
      const user = this.$store.state.userinfo
      return user && user.id == this.authUser.id
    },
    loginUser() {
      return this.$store.getters['loginUser']
    },
    wxfetchParams() {
      return {
        name: 'yida'
      }
    },
    shareConfig() {
      if (this.$isServer) return {}
      const { env } = this.$runningEnv
      const s = env ? `-${env}` : ''
      const link = `https://m${s}.xinli001.xin/qa/${this.questionId}?is_share=1&node=1`

      return {
        title: this.detail.title,
        desc: `${this.loginUser.nickname || ''}邀请你一起帮助ta`,
        imgUrl: `https://lapp${s}.xinli001.com/images/website-mobile/qa_logo.jpg`,
        link
      }
    },
    // 是否咨询目标用户
    isConsultTarget() {
      return +this.detail?.isConsultTarget === 1 || false
    },
    similarGroupList() {
      return this.$store.state.qaQuestionDetail?.similarGroupList || []
    }
  },
  onAppWebviewShow() {
    this.fetchQuestionDetail()
  },
  mounted() {
    if (this.$platform.isYixinliApp) {
      this.$bridge.call('switchNavigationBar', {
        isHidden: 1
      })
    }
    window.addEventListener('scroll', this.watchTop)

    Promise.all([
      this.$store.dispatch('getUserInfo').catch(err => {
        console.log(err)
      }),
      this.fetchQuestionDetail()
    ]).finally(() => {
      this.inited = true
      if (!this.qaAnswerList || !this.qaAnswerList.length) {
        const { zixunTagShotList, categoryIdList } = this.detail
        if (this.isConsultTarget) {
          this.$store.dispatch('qaQuestionDetail/fetchTeacherListAb', {
            size: 3,
            tag: Array.isArray(zixunTagShotList)
              ? zixunTagShotList.map(v => v.customeTagId).join(',')
              : []
          })
        } else {
          this.$store.dispatch('qaQuestionDetail/fetchQingtingList', {
            page: 1,
            size: 3,
            category: Array.isArray(categoryIdList)
              ? categoryIdList.map(v => v).join(',')
              : ''
          })
        }
      }
      this.$trackPageView('qa_question_details_view', {
        ...this.questionTags,
        qa_id: this.questionId, //问题ID
        is_offer: !!this.detail.rewardInfo, //是否悬赏
        commend_business_type: this.isConsultTarget ? ['咨询'] : ['倾诉']
      })
    })

    if (this.qaAnswerList.length) {
      commonGetToken(this).then(token => {
        this.$store.dispatch('qaQuestionDetail/fetchFlowAd', {
          name: 'qa_q_feed',
          token
        })
      })
    }

    // 没那么重要的延迟一点加载
    setTimeout(() => {
      // this.$store.dispatch('qaQuestionDetail/fetchSimilarityProblem', {
      //   questionId: this.questionId
      // })
      // this.$store.dispatch('qaQuestionDetail/fetchRelatedReading', {
      //   questionId: this.questionId
      // })
      this.mixinFetchOperateFlag({
        objectType: 5,
        objectId: this.questionId
      })
      this.renderQaCommonAd = true
    }, 100)
    // 提前获取statusBarHeight，避免打开answerDialog组件时抖动
    const { isYixinliApp, isZiXunApp } = this.$platform
    if (isYixinliApp || isZiXunApp) {
      getStatusBarHeight().then(h => {
        localStorage.setItem('global_status_bar_height', h)
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.watchTop)
  },
  methods: {
    toggleBodyVisiable(val) {
      this.$refs.container.classList[val ? 'add' : 'remove']('hide-max')
    },
    goAnswerDes(item) {
      this.$trackEvent('qa_question_details_a_operation', {
        ...this.questionTags,
        qa_id: this.questionId,
        answer_id: item.baseContentVo.objectId,
        operation: '查看详情'
      })
    },
    answerToUserHome(item) {
      this.$trackEvent('qa_question_details_a_operation', {
        ...this.questionTags,
        qa_id: this.questionId,
        answer_id: item.baseContentVo.objectId,
        operation: '查看作者'
      })
    },
    answerReportFinish(item) {
      this.$trackEvent('qa_question_details_a_operation', {
        ...this.questionTags,
        qa_id: this.questionId,
        answer_id: item.baseContentVo.objectId,
        operation: '举报'
      })
    },
    answerLikeFinish(item) {
      this.$trackEvent('qa_question_details_a_interaction', {
        ...this.questionTags,
        qa_id: this.questionId,
        answer_id: item.baseContentVo.objectId,
        interaction_type: '点赞'
      })
      this.fetchQuestionDetail()
    },
    answerFollowFinish(item) {
      this.$trackEvent('qa_question_details_a_interaction', {
        ...this.questionTags,
        qa_id: this.questionId,
        answer_id: item.baseContentVo.objectId,
        interaction_type: '关注'
      })
      this.fetchQuestionDetail()
    },
    shareSuccessFn() {
      return increaseInvite().then(res => {
        if (+res.code === 0) {
          console.log('分享成功')
        }
      })
    },
    refreshAnswerList() {
      this.$nextTick(() => {
        this.$refs.answerList.refreshAnswerList()
      })
    },
    fetchQuestionDetail(params = {}) {
      return commonGetToken(this).then(token => {
        return this.$store
          .dispatch('qaQuestionDetail/fetchQuestionDetail', {
            ...params,
            id: this.questionId,
            token
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    watchTop() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 40) {
        this.isSticky = true
      } else {
        this.isSticky = false
      }
    },
    navGoback() {
      this.routerGoback()
    },
    handleShare() {
      if (this.$platform.isYixinliApp) {
        this.$bridge.shareReport({
          ...this.shareConfig,
          isShowReport: this.isOnwer ? 0 : 1, // 是否显示举报
          isShowDangerReport: this.mixinShowCrisisBtn ? 1 : 0, // 是否显示危机上报
          newObjectType: 5, // 业务类型。 1:动态 2:文章 3:回答 4:直播 5:提问 6:FM 7:短视频 8:话题 9:群聊 10:用户 12:聊天室
          object_id: this.questionId,
          sourcePage: '问题详情页',
          itemName: '问题详情链接',
          success: () => {
            this.shareSuccessFn()
          },
          operateSuccess: opt => {
            // 危机上报成功
            if (opt.shareChannel === 'dangerReport') {
              this.mixinFetchOperateFlag({
                objectType: 5,
                objectId: this.questionId
              })
            }
          }
        })
      }
    },
    openAnswerDialog() {
      this.$refs.answerDialog.showDialog = true
    },
    answerTrack() {
      this.$trackEvent('qa_release_answer_success', {
        ...this.questionTags,
        qa_id: this.$route.params.id, //问题ID
        is_offer: !!this.detail.rewardInfo, //是否悬赏
        order_amount: this.detail.rewardInfo?.money || 0
      })
    },
    toServices() {
      this.$trackEvent('qa_question_details_help_more', {
        ...this.questionTags,
        qa_id: this.$route.params.id, //问题ID
        commend_business_type: this.isConsultTarget ? ['咨询'] : ['倾诉']
      })
    },
    // 发布完回答生成海报
    async handlePoster(objectId) {
      await this.$store.dispatch('qaQuestionDetail/fetchPosterShareData', {
        objectType: 3,
        objectId
      })
      await this.$refs.poster.initPoster('isLoading')
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.hide-max {
  display: none !important;
}
.question-detail {
  padding-bottom: 240px;
  // background-color: #f8f9ff;
}
.gray-line {
  width: 750px;
  height: 20px;
  background: #f2f4ff;
}
.header-content {
  height: 100%;
  color: initial;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  box-sizing: border-box;
  .back-btn {
    width: 18px;
    height: 34px;
  }
  .share-btn {
    width: 36px;
    height: 36px;
  }
  .head-l {
    display: flex;
    align-items: center;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  // .header-m {
  //   padding: 0 16px;
  //   flex: 1;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  //   white-space: nowrap;
  //   font-size: 36px;
  //   font-weight: 600;
  //   color: #000000;
  //   box-sizing: border-box;
  // }
  .header-r {
    display: flex;
    align-items: center;
  }
}
.header {
  ::v-deep .head-middle {
    height: 100% !important;
  }
  ::v-deep .header-left,
  ::v-deep .header-right {
    display: none !important;
  }
}
</style>
